.accordion {
  width: 100%;
  --slide-distance: 20%;
  composes: slideLeft from global;
}

.accordionItem {
  background-color: white !important;
}

.accordionContent {
  overflow: hidden;
  background-color: var(--app-background-color) !important;
}

.searchOptions {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

.searchInput {
  margin-top: 25px;
  max-width: 300px;
}

.addButton {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}
